import React from 'react';
import Field, { hasDataInFields } from '../../Field';
import { MembershipButton } from '../../../../components';
import css from './CustomMembership.module.css';

/**
 * CustomMembership - Renders the membership CTA section
 * Used when sectionId === 'memberships-join-header'
 *
 * Displays a title, description, and the MembershipButton component
 * which handles authentication and Stripe checkout flow.
 */
const CustomMembership = ({ title, description, options }) => {
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, description], fieldOptions);

  return (
    <div className={css.root}>
      {hasHeaderFields && (
        <div className={css.header}>
          <Field data={title} className={css.title} options={fieldOptions} />
          <Field data={description} className={css.description} options={fieldOptions} />
        </div>
      )}

      <div className={css.buttonWrapper}>
        <MembershipButton />
      </div>
    </div>
  );
};

export default CustomMembership;
